function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState, useCallback, useMemo, createContext, useContext, useReducer } from 'react';
import { createPortal } from 'react-dom';
import useWindowWidth from '../../hooks/useWindowWidth';
import useScrolling from '../../hooks/useScrolling';
import cs from 'classnames';
import tabbable from 'tabbable';
import { injectIntl } from 'react-intl';
import KEYCODES from '../../utils/KEYCODES';
import debounce from '../../utils/debounce';
import tint from '../../utils/colors/tint';
import styles from './Menu.module.scss';
import ClientColorCss from '../../ClientColorCss/ClientColorCss';
import { formatI18n } from '../../I18n/I18n/I18n';
import ThemeContext from '../../ThemeContext';
import MenuZIndexContext, { Z_INDEX_ABOVE_DRAWER } from './MenuZIndexContext';
// change with $caret-height in Menu.module.scss!
var CARET_HEIGHT = 8;
var preventDefault = function preventDefault(which) {
  return [KEYCODES.TAB, KEYCODES.UP_ARROW, KEYCODES.DOWN_ARROW].includes(which);
};
export var MenuContext = createContext(undefined);
function isEqual(obj1, obj2) {
  var obj1Keys = Object.keys(obj1);
  return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function (key) {
    return obj1[key] === obj2[key];
  });
}
var initialState = {
  top: 0,
  left: 'auto',
  right: 'auto',
  visibility: 'hidden',
  inverted: false,
  zIndex: Z_INDEX_ABOVE_DRAWER
};
function positionReducer(state, action) {
  if (isEqual(state, action.payload)) {
    return state;
  } else {
    return action.payload;
  }
}
function getScrollParent(element) {
  if (!element) {
    return document.body;
  }
  // @ts-ignore
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRegex = /(auto|scroll|hidden)/;
  if (style.position === 'fixed') return document.body;
  // @ts-ignore
  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.body;
}

/**
 * Calculates how to position the menu based on the orientation and relative
 * to the triggering button
 */
function useMenuPosition(buttonRef, menuRef, orientation, expanded) {
  var width = useWindowWidth();
  var _useScrolling = useScrolling(),
    _useScrolling2 = _slicedToArray(_useScrolling, 2),
    scrollY = _useScrolling2[1];
  var _useReducer = useReducer(positionReducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    position = _useReducer2[0],
    dispatch = _useReducer2[1];
  var zIndex = useContext(MenuZIndexContext);
  var theme = useContext(ThemeContext);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    parentScrollY = _useState2[0],
    setParentScrollY = _useState2[1];
  useEffect(function () {
    var button = buttonRef.current;
    if (button) {
      var parent = getScrollParent(button);
      if (parent) {
        var handler = debounce(function () {
          return setParentScrollY(parent.scrollTop);
        }, 100);
        parent.addEventListener('scroll', handler);
        return function () {
          return parent.removeEventListener('scroll', handler);
        };
      }
    }
  }, [buttonRef]);
  useEffect(function () {
    var button = buttonRef.current;
    var menu = menuRef.current;
    if (button && menu) {
      var _button$getBoundingCl = button.getBoundingClientRect(),
        left = _button$getBoundingCl.left,
        right = _button$getBoundingCl.right,
        bottom = _button$getBoundingCl.bottom,
        _width = _button$getBoundingCl.width,
        height = _button$getBoundingCl.height;
      var _menu$getBoundingClie = menu.getBoundingClientRect(),
        menuHeight = _menu$getBoundingClie.height;
      var top = window.pageYOffset + bottom;
      var visibility = top ? 'visible' : 'hidden';
      var inverted = false;
      if (bottom + menuHeight + CARET_HEIGHT > window.innerHeight) {
        top = top - height - menuHeight;
        inverted = true;
      }
      if (theme === 'ripple') {
        orientation = 'right';
      }
      switch (orientation) {
        case 'left':
          dispatch({
            type: 'left',
            payload: {
              top: top,
              left: left,
              visibility: visibility,
              inverted: inverted,
              zIndex: zIndex
            }
          });
          break;
        case 'right':
          dispatch({
            type: 'right',
            payload: {
              top: top,
              right: document.documentElement.clientWidth - right,
              visibility: visibility,
              inverted: inverted,
              zIndex: zIndex
            }
          });
          break;
        case 'center':
          dispatch({
            type: 'center',
            payload: {
              top: top,
              left: left + _width / 2,
              visibility: visibility,
              inverted: inverted,
              zIndex: zIndex
            }
          });
          break;
      }
    }
  }, [buttonRef, orientation, width, expanded, menuRef, scrollY, zIndex, parentScrollY]);
  return position;
}

/**
 * Note the use of useCallback in this component to ensure stable function identity
 * which can prevent unnecessary rerenders or re-runs of effects when the function
 * inputs aren't changing.
 */
function Menu(_ref) {
  var label = _ref.label,
    intl = _ref.intl,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'center' : _ref$orientation,
    button = _ref.button,
    children = _ref.children,
    className = _ref.className;
  // timeoutId for focusing el
  var timeoutId = useRef();
  // for sort mimicking a componentDidUpdate
  var updateRef = useRef(false);
  // theme
  var theme = useContext(ThemeContext);
  // state
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1]; // using useCallback is just a convenience in this case
  var closeMenu = useCallback(function () {
    return setExpanded(false);
  }, []);
  var openMenu = useCallback(function () {
    return setExpanded(true);
  }, []);
  // refs
  var menuRef = useRef(null);
  var buttonRef = useRef(null);
  // positioning
  var _useMenuPosition = useMenuPosition(buttonRef, menuRef, orientation, expanded),
    inverted = _useMenuPosition.inverted,
    menuPosition = _objectWithoutProperties(_useMenuPosition, ["inverted"]); // assign button prop to Capitalized version so React treats it as a component
  var Button = button;

  /**
   * Keyboard functionality:
   * - UP/DOWN arrows move up and down the menu items (looping around if necessary)
   *   - using arrow keys allows focusuing of disabled items, but action cannot be taken
   * - TAB need to separately handle tabbing due to our use of Portals
   *   - Tabbing does not go to menuitems, but rather moves to the logical place
   *     in the tab order
   *   - If SHIFT+TAB to trigger button, menu stays open
   *     - At this point hitting DOWN arrow will go back into menu
   * - ESC closes the menu and puts focus on the trigger button
   */
  var handleMenuKeyDown = useCallback(function (e) {
    e.stopPropagation();
    var ref = menuRef.current;
    var button = buttonRef.current;
    if (ref && e.target && button) {
      var menuitems = Array.from(ref.querySelectorAll('[role="menuitem"]'));
      var currentIndex = menuitems.findIndex(function (el) {
        return el === e.target;
      });
      var toFocus = null;
      if (preventDefault(e.which)) {
        e.preventDefault();
      }
      switch (e.which) {
        case KEYCODES.TAB:
          // need to handle tabbing
          if (e.shiftKey) {
            button.focus();
          } else {
            var tabbables = tabbable(document.body);
            var _currentIndex = tabbables.findIndex(function (el) {
              return el === button;
            });
            toFocus = tabbables[_currentIndex + 1];
            closeMenu();
          }
          break;
        case KEYCODES.DOWN_ARROW:
          // get next index or first if at end of array
          toFocus = menuitems[(currentIndex + 1) % menuitems.length];
          break;
        case KEYCODES.UP_ARROW:
          // get previous index or last if at beginning of array
          toFocus = menuitems[(currentIndex || menuitems.length) - 1];
          break;
        case KEYCODES.ESC:
          closeMenu();
      }
      toFocus && toFocus.focus();
    }
  }, [closeMenu]);
  useEffect(function () {
    function handleDocumentClick(e) {
      var ref = menuRef.current;
      var target = e.target;
      if (expanded && ref && target) {
        if (!ref.contains(target)) {
          closeMenu();
        }
      }
    }
    document.addEventListener('click', handleDocumentClick, false);
    return function () {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [closeMenu, expanded]);

  /**
   * Keyboard functionality:
   * - UP or ESC arrow closes the menu
   * - DOWN arrow opens the menu if it's not open, otherwise moves to first menu item
   * - ENTER or SPACEBAR opens the menu
   */
  var handleButtonKeyDown = useCallback(function (e) {
    var ref = menuRef.current;
    var btnRef = buttonRef.current;
    if (btnRef) {
      switch (e.which) {
        case KEYCODES.UP_ARROW:
        case KEYCODES.ESC:
          e.preventDefault();
          closeMenu();
          return;
        case KEYCODES.DOWN_ARROW:
          e.preventDefault();
          if (expanded && ref) {
            var firstEnabled = Array.from(ref.querySelectorAll('[role="menuitem"]'))[0];
            firstEnabled && firstEnabled.focus();
          } else {
            openMenu();
          }
      }
    }
  }, [closeMenu, expanded, openMenu]);
  var handleButtonBlur = useCallback(function (e) {
    // IE doesn't support e.relatedTarget, but this hack works
    // source: https://stackoverflow.com/a/49325196
    var target = e.relatedTarget || document.activeElement;
    var ref = menuRef.current;
    // when blurring the button, if we are not moving focus into the menu we
    // want to close the menu while also ensuring the intended target receives
    // focus (if we don't do this, SHIFT+TABing will cause a double stop on
    // the menu trigger button)
    if (ref && !ref.contains(target)) {
      target && target.focus();
      closeMenu();
    }
  }, [closeMenu]);

  // useMemo here to have buttonProps have a stable identity reference if things
  // don't change (object literal wouldn't do this)
  var buttonProps = useMemo(function () {
    return {
      ref: buttonRef,
      type: 'button',
      'aria-expanded': expanded,
      'aria-haspopup': true,
      onClick: function onClick() {
        return setExpanded(!expanded);
      },
      onKeyDown: handleButtonKeyDown,
      onBlur: handleButtonBlur,
      className: styles.trigger
    };
  }, [expanded, handleButtonKeyDown, handleButtonBlur]);
  var setRef = useCallback(function () {
    for (var _len = arguments.length, otherRefs = new Array(_len), _key = 0; _key < _len; _key++) {
      otherRefs[_key] = arguments[_key];
    }
    return function (el) {
      // allow setting multiple additional refs, for things like tooltips
      otherRefs.forEach(function (otherRef) {
        if (typeof otherRef === 'function') {
          otherRef(el);
        } else if (otherRef) {
          otherRef.current = el;
        }
      });
      // set the ref we use in this component
      buttonRef.current = el;
    };
  }, []);

  // handles focus when opening and closing the menu
  useEffect(function () {
    var ref = menuRef.current;
    var btnRef = buttonRef.current;
    if (updateRef.current) {
      if (ref && expanded) {
        var firstEnabled = Array.from(ref.querySelectorAll('[role="menuitem"]')).find(function (el) {
          return el.getAttribute('aria-disabled') !== 'true';
        });
        clearTimeout(timeoutId.current);
        timeoutId.current = window.setTimeout(function () {
          return firstEnabled && firstEnabled.focus();
        }, 100);
      } else if (btnRef &&
      // menu is closing
      !expanded &&
      // focus got lost
      document.activeElement === document.body) {
        btnRef.focus();
      }
    } else {
      updateRef.current = true;
    }
  }, [expanded]);
  return /*#__PURE__*/React.createElement(MenuContext.Provider, {
    value: closeMenu
  }, theme === 'dm' && /*#__PURE__*/React.createElement(ClientColorCss, {
    id: styles.menu
  }, function (_ref2) {
    var trimColorSecondary = _ref2.trimColorSecondary;
    return ".".concat(styles["menu--dm"], " { background-color: ").concat(tint(trimColorSecondary, 75), " }\n\t\t\t\t\t.").concat(styles["menu--dm"], "::before { border-bottom-color: ").concat(tint(trimColorSecondary, 75), " }\n\t\t\t\t\t.").concat(styles["menu--dm"], " [role=\"menuitem\"]:hover,\n\t\t\t\t\t.").concat(styles["menu--dm"], " [role=\"menuitem\"]:focus {\n\t\t\t\t\t\tbackground-color: ").concat(trimColorSecondary, "\n\t\t\t\t\t}");
  }), /*#__PURE__*/React.createElement(Button, {
    buttonProps: buttonProps,
    setRef: setRef,
    expanded: expanded
  }), createPortal(expanded && /*#__PURE__*/React.createElement("div", {
    ref: menuRef,
    role: "menu",
    "aria-label": label ? formatI18n(intl, label) : '',
    className: cs(styles.menu, styles["menu--".concat(theme)], styles[theme === 'ripple' ? 'right' : orientation], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, String(className), className), styles.above, inverted), styles.below, !inverted), "".concat(styles.center, "--above"), inverted && orientation === 'center')),
    onKeyDown: handleMenuKeyDown,
    style: menuPosition
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles.wrapper, styles["wrapper--".concat(theme)])
  }, children)), document.body));
}
export default injectIntl(Menu);